import { Button, DatePicker, Form, Modal, Radio, Select } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconSuccess from '../../../../assets/Images/icons/icon-success';
import ConsentService from '../../../../services/Consent.service';
import useNotify from '../../../../context/Notification/useNotify';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useParams } from 'react-router-dom';
dayjs.extend(customParseFormat);
function ModalAcceptance({
    handelClose,
    open,
    detailConsentData,
    getDetailConsent,
    getHistoryDetail,
    form,
    username,
}) {
    const notify = useNotify();
    const { t } = useTranslation();
    const { id } = useParams();

    // const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [verionList, setVerionList] = useState([]);

    useEffect(() => {
        const data = detailConsentData;
        form.setFieldsValue({
            isAccept: data?.status === 'Accepted' ? true : false,
            consentDate: moment(new Date(), 'DD/MM/YYYY HH:mm'),
        });
        getVersion(detailConsentData?.consentTxnGroupId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailConsentData]);

    const getVersion = async (id) => {
        const { data } = await ConsentService.getVersion(id);
        const list = data?.resultData?.versionList;
        form?.setFieldValue('version', list[0]?.version);
        setVerionList(list);
    };

    const _handelClose = () => {
        handelClose();
    };

    const onFinish = async (value) => {
        const payload = {
            consentTxnGroupId: detailConsentData?.consentTxnGroupId,
            isAccept: value.isAccept,
            consentDate: moment(value?.consentDate).format('DD/MM/YYYY HH:mm'),
            identity: id,
            version: value?.version,
        };
        console.log(payload);
        try {
            setLoading(true);
            const { data } = await ConsentService.reconsent(payload);
            if (data?.resultCode === 1) {
                setLoading(false);
                handelClose();
                await getDetailConsent();
                await getHistoryDetail();
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to save data'),
                    timeOut: 3000,
                });
            } else {
                setLoading(false);
                handelClose();
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to save data'),
                    closeable: true,
                });
            }
        } catch (error) {
            setLoading(false);
            handelClose();
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to save data'),
                closeable: true,
            });
        }
    };

    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current > dayjs().endOf('day');
    };

    return (
        <Modal
            width={480}
            className="_modal"
            footer={false}
            open={open}
            onCancel={_handelClose}
            closable={false}
            afterClose={() => {
                const data = detailConsentData;
                form.setFieldsValue({
                    isAccept: data?.status === 'Accepted' ? true : false,
                    consentDate: moment(new Date(), 'DD/MM/YYYY HH:mm'),
                });
            }}
        >
            <div className="space-y-3 p-2">
                <div className="text-center">
                    <IconSuccess />
                </div>
                <div className="text-1xl text-center">
                    {t('Consent.ChangeConsentStatus')}
                </div>
                <Form onFinish={onFinish} form={form} layout="vertical">
                    <Form.Item
                        name={'isAccept'}
                        label={t('Consent.Status')}
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Radio.Group className="flex text-center">
                            <Radio
                                className={`flex-1 rounded-lg p-3 bg-[#F5F6FF] w-full`}
                                key={1}
                                value={true}
                            >
                                {t('Consent.Accept')}
                            </Radio>
                            <Radio
                                className={`flex-1 rounded-lg p-3 mr-0 bg-[#F5F6FF] w-full`}
                                key={2}
                                value={false}
                            >
                                {t('Consent.Reject')}
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        label={t('Consent.ConsentDate')}
                        name="consentDate"
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <DatePicker
                            disabledDate={disabledDate}
                            style={{ width: '100%' }}
                            size="large"
                            showTime
                            format="DD/MM/YYYY HH:mm"
                            placeholder={t('Consent.Pleaseselectdate')}
                        />
                    </Form.Item>
                    <Form.Item
                        label={t('Consent.Version')}
                        name="version"
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Select
                            size="large"
                            placeholder={`${t('Select')} ${t(
                                'Consent.Version'
                            )}`}
                        >
                            {verionList.map((e) => {
                                return (
                                    <Select key={e.version} value={e.version}>
                                        {e.version}
                                    </Select>
                                );
                            })}
                        </Select>
                    </Form.Item>
                    <div>
                        <div>{t('Consent.UpdateBy')}</div>
                        {/* <div>{detailConsentData?.updateBy || '-'}</div> */}
                        <div>{username || '-'}</div>
                    </div>
                    <div className="mt-9 flex justify-center space-x-3">
                        <Button
                            onClick={() => {
                                handelClose();
                            }}
                            className="min-w-[120px] border-[#7B67FB] text-[#7B67FB]"
                            size="large"
                            loading={loading}
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            className="min-w-[120px]"
                            size="large"
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                        >
                            {t('common.Confirm')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
}

export default ModalAcceptance;
